.bw{max-width:100%;}